import { Link } from 'react-router-dom';
import { casesData } from '@/mocks/casesData';

interface CasesRelacionadosProps {
  serviceSlugs: string[];
  title?: string;
}

export default function CasesRelacionados({ serviceSlugs, title = 'Cases Relacionados' }: CasesRelacionadosProps) {
  const relatedCases = casesData.cases.filter(
    (c) => c.relatedServices.some((s) => serviceSlugs.includes(s))
  );

  if (relatedCases.length === 0) return null;

  return (
    <section className="relative py-20 bg-gp-graphite-light border-t border-gp-graphite-lighter">
      <div className="px-4 sm:px-6 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-[3px] bg-gp-yellow"></div>
            <h2 className="font-display text-2xl font-bold text-white uppercase tracking-wider">{title}</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {relatedCases.map((caseItem) => (
              <article
                key={caseItem.id}
                className="group bg-gp-graphite border border-gp-graphite-lighter rounded-lg overflow-hidden hover:border-gp-yellow/30 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={caseItem.cardImage}
                    alt={caseItem.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-gp-graphite via-transparent to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className={`inline-block px-2 py-1 rounded-sm text-xs font-semibold uppercase tracking-wider ${
                      caseItem.category === 'oficina'
                        ? 'bg-gp-yellow text-gp-graphite'
                        : 'bg-gp-blue text-white'
                    }`}>
                      {caseItem.categoryLabel}
                    </span>
                  </div>
                  <div className="absolute bottom-3 left-3">
                    <span className="text-gray-400 text-xs uppercase tracking-wider">{caseItem.clientSegment}</span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="font-display text-sm font-bold text-white uppercase mb-2 group-hover:text-gp-yellow transition-colors duration-300 line-clamp-2">
                    {caseItem.title}
                  </h3>
                  <p className="text-gray-400 text-xs leading-relaxed mb-3 line-clamp-2">
                    {caseItem.shortDesc}
                  </p>
                  <Link
                    to={`/${caseItem.slug}`}
                    className="inline-flex items-center gap-1 text-gp-yellow hover:text-gp-yellow-dark text-xs font-semibold uppercase tracking-wider transition-colors duration-300"
                  >
                    Ver Case Completo
                    <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center"></i>
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}